import gql from 'graphql-tag'

export const CREATE_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent($input: CreatePaymentIntentInput) {
    createPaymentIntent(input: $input) {
      id,
      status,
      clientSecret
    }
  }
`

export const UPDATE_PAYMENT_INTENT = gql`
  mutation updatePaymentIntent($input: UpdatePaymentIntentInput!) {
    updatePaymentIntent(input: $input) {
      id
      status
      metadata {
        entityId
        invoices
        amounts
      }
    }
  }
`
